import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { LoadingSpinner } from "@/components/Loading";
import { Text } from "@/components/Text";
import { unsubscribe } from "@/data/session";
import { Flex, Img } from "@/eworkitComponents";
import { withRouteProps } from "@/infrastructure/Route";
import { AnimatedLayoutContainer } from "@/views/components/Layout";

import { transformUnsubscribeRouteProps } from "./selectors";
import { IUnsubscribeRouteProps } from "./types";
import unsubscribeErrorImg from "./unsubscribe-error.svg";
import unsubscribeSuccessImg from "./unsubscribe-success.svg";

type TUnsubscribeResult = "success" | "error";

interface IUnsubscribePageProps extends IUnsubscribeRouteProps {}

const UnsubscribePageComponent: FC<IUnsubscribePageProps> = ({ routeProps }) => {
  const { t } = useTranslation("public");

  const [result, setResult] = useState<TUnsubscribeResult>();

  useEffect(() => {
    const invokeUnsubscribe = async () => {
      try {
        await unsubscribe({}, { token: routeProps.token });
        setResult("success");
      } catch (error) {
        setResult("error");
      }
    };

    invokeUnsubscribe();
  }, []);

  return (
    <AnimatedLayoutContainer size="md" showLogo>
      {!result ? (
        <Flex align="center" justify="center">
          <LoadingSpinner size="lg" variant="primary" />
        </Flex>
      ) : (
        <Flex direction="column" innerMargin="lg" padding={[false, "lg"]}>
          <Header size="lg" weight="bold" color="black" align="center">
            {result === "success" ? t("UNSUBSCRIBE.SUCCESS_HEADER") : t("UNSUBSCRIBE.ERROR_HEADER")}
          </Header>

          {result === "success" ? <Img src={unsubscribeSuccessImg} /> : <Img src={unsubscribeErrorImg} />}

          <Text color="black" size="lg">
            {result === "success" ? t("UNSUBSCRIBE.SUCCESS_TEXT") : t("UNSUBSCRIBE.ERROR_TEXT")}
          </Text>
          <Text color="black" size="lg">
            {t("UNSUBSCRIBE.YOU_CAN_SUBSCRIBE_AGAIN")}
          </Text>
        </Flex>
      )}
    </AnimatedLayoutContainer>
  );
};

export const UnsubscribePage = withRouteProps(UnsubscribePageComponent, transformUnsubscribeRouteProps);
